import React from 'react';
import Grid from '@mui/material/Grid';
import { useDispatch, useSelector } from 'react-redux';
import FormInputText from '../../../../../common/Forms/FormTextField';
import DropdownFormInput from '../../../../../common/Forms/DropdownForm';
import {
  setInstitutionGender,
  setPrisonCode,
  setPrisonNumber,
} from '../../../../../../redux/organization/organizationTabs/organizationInstitution/organizationInstitutionSlice';

const InstitutionForm = (props) => {
  const { control, defaultValue, register, errors } = props;
  const dispatch = useDispatch();

  const organizationReferenceData = useSelector(
    (state) => state.organizationReferenceData
  );
  const { genderList } = organizationReferenceData;

  return (
    <>
      <Grid container spacing={2} style={{ marginTop: '0px' }}>
        <Grid item xs={12} sm={4}>
          <FormInputText
            name='prisonCode'
            type='text'
            control={control}
            errors={!!errors.prisonCode}
            helperText={errors?.prisonCode?.message}
            label='Prison Code'
            register={register('prisonCode', {
              onChange: (e) => dispatch(setPrisonCode(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormInputText
            name='prisonNumber'
            type='number'
            control={control}
            label='Prison Number'
            register={register('prisonNumber', {
              onChange: (e) => dispatch(setPrisonNumber(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <DropdownFormInput
            name='institutionGender'
            control={control}
            options={genderList}
            defaultId={defaultValue?.institutionGender}
            label='Gender'
            register={register('institutionGender', {
              onChange: (e) => dispatch(setInstitutionGender(e.target.value)),
            })}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default InstitutionForm;
